"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicSet = void 0;
const class_validator_1 = require("class-validator");
class PublicSet {
    constructor(data) {
        this.id = data.id;
        this.groups = data.groups;
        this.name = data.name;
        this.thumb = data.thumb;
        this.order = data.order;
    }
}
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicSet.prototype, "id", void 0);
__decorate([
    class_validator_1.IsString({ each: true }),
    __metadata("design:type", Array)
], PublicSet.prototype, "groups", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicSet.prototype, "name", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicSet.prototype, "thumb", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", Number)
], PublicSet.prototype, "order", void 0);
exports.PublicSet = PublicSet;
// export class Set extends NetworkModel implements ISet {
// 	@IsString()
// 	id!: SetId
// 	@IsString()
// 	name!: string
// 	@IsString()
// 	thumb!: string
// 	@IsNumber()
// 	order: number = DEFAULT_ORDER
// 	@IsString({ each: true })
// 	groups: string[] = []
// 	@IsBoolean()
// 	visible: boolean = true
// }
